<ng-container *ngIf="loading; else content">
    <app-welcome-loader class="page-loader"></app-welcome-loader>
</ng-container>

<ng-template #content>
    <!-- Breadcrumb -->
    <div class="breadcrumb-card mb-25 d-md-flex align-items-center justify-content-between">
        <h5 class="mb-0">
            {{ 'Plant_details' | translate }}
        </h5>
        <ol class="breadcrumb list-unstyled mt-0 mb-0 pl-0">
            <li class="breadcrumb-item position-relative">
                <a routerLink="/" class="d-inline-block position-relative">
                    <i class="ri-home-8-line"></i>
                    {{ 'Dashboard'| translate }}
                </a>
            </li>
            <li class="breadcrumb-item position-relative">
                <a class="plants-link-breadcrumb" routerLink="/plants/all-plant-list">
                    {{ 'Plants_list' | translate }}
                </a>
            </li>
            <li class="breadcrumb-item position-relative">
                {{ 'Plant_details' | translate }}
            </li>
        </ol>
    </div>

    <!-- My image Plants  -->
    <mat-card class="daxa-card profile-card mb-25 p-0 border-radius bg-white border-none d-block">
        <mat-card-content>
            <div class="cover-image position-relative border-radius">

                <div class="ref-chips-container" *ngIf="externalReferences?.length">
                    <div class="ref-chip-list">
                        <mat-chip *ngFor="let ref of externalReferences" class="ref-chip"
                            [ngClass]="'ref-chip-' + (ref.serviceName | lowercase)" matTooltipClass="ref-tooltip"
                            matTooltipPosition="below">
                            <span class="ref-chip-label">{{ ref.serviceName }} : </span>
                            <span class="ref-chip-value">{{ ref.serviceValue }}</span>
                        </mat-chip>
                    </div>
                </div>

                <img src="images/profile-big-cover.jpg" class="border-radius" alt="cover-image" />

                <div class="profile-content">
                    <div class="btn-box">
                        <button matFab mat-button (click)="goToUpdatePlant()" class="badge text-outline-success">
                            <mat-icon>edit</mat-icon>
                            {{'Update_plant' | translate}}
                        </button>
                        <button matFab mat-button (click)="onAddInverter()" class="badge text-outline-success">
                            <mat-icon>add</mat-icon>
                            {{'add_inverter' | translate}}
                        </button>
                    </div>
                </div>
            </div>
        </mat-card-content>

    </mat-card>
    <!-- My Plants Info -->
    <mat-card class="daxa-card profile-card mb-25 p-0 border-radius border-none top-info-card">
        <div class="d-md-flex align-items-center justify-content-center boxs-holder">
            <div class="container align-items-center justify-content-center d-md-flex">
                <div class="col-md-3 col-sm-12 information-box">
                    <div class="icon-box">
                        <mat-icon>
                            account_circle
                        </mat-icon>
                    </div>
                    <div class="content-box">
                        <div class="key">
                            {{'owner_name' | translate}}
                        </div>
                        <div class="value">
                            {{plantInfo?.plantOwner}}
                        </div>
                    </div>
                </div>
                <div class="col-md-3 col-sm-12 information-box">
                    <div class="icon-box">
                        <mat-icon>
                            badge
                        </mat-icon>
                    </div>
                    <div class="content-box">
                        <div class="key">
                            {{'Username' | translate}}
                        </div>
                        <div class="value">
                            {{plantInfo?.userName}}
                        </div>
                    </div>
                </div>
                <div class="col-md-3 col-sm-12 information-box">
                    <div class="icon-box" aria-hidden="true">
                        <mat-icon *ngIf="!plantInfo?.disabled" class="status-on" aria-label="active">mood</mat-icon>
                        <mat-icon *ngIf="plantInfo?.disabled" class="status-off"
                            aria-label="disabled">mood_bad</mat-icon>
                    </div>

                    <div class="content-box">
                        <div class="key">{{'Status' | translate}}</div>
                        <div class="value">
                            {{ plantInfo?.disabled ? 'Disabled' : 'Active' }}
                        </div>
                    </div>
                </div>
                <div class="col-md-3 col-sm-12 information-box">
                    <div class="icon-box">
                        <mat-icon>
                            phone_in_talk
                        </mat-icon>
                    </div>
                    <div class="content-box">
                        <div class="key">
                            {{'Phone_number' | translate}}
                        </div>
                        <div class="value">
                            {{plantInfo?.phoneNumber}}
                        </div>
                    </div>
                </div>
                <div class="col-md-3 col-sm-12 information-box">
                    <div class="icon-box">
                        <mat-icon>
                            fingerprint
                        </mat-icon>
                    </div>
                    <div class="content-box">
                        <div class="key">
                            {{'Plant_Id' | translate}}
                        </div>
                        <div class="value">
                            {{plantInfo?.id}}
                        </div>
                    </div>
                </div>
                <div class="col-md-3 col-sm-12 information-box">
                    <div class="icon-box">
                        <mat-icon>
                            {{ plantInfo?.installationDate ? 'event' : 'event_busy' }}
                        </mat-icon>
                    </div>

                    <div class="content-box">
                        <div class="key">
                            {{ 'Installation_date' | translate }}
                        </div>

                        <div class="value">
                            <ng-container *ngIf="plantInfo?.installationDate; else notSet">
                                {{ plantInfo?.installationDate | installationDate }}
                            </ng-container>

                            <ng-template #notSet>
                                <span class="not-set-value">
                                    <mat-icon class="not-set-icon">block</mat-icon>
                                    {{ 'Not_set' | translate }}
                                </span>
                            </ng-template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </mat-card>
    <!-- Grid boxes -->
    <div class="daxa-card profile-card mb-25 p-0 border-radius border-none inverter-info">
        <div class="container-fluid">
            <div class="row g-3">
                <div class="daxa-card col-4 grid-boxes">
                    <div class="card">
                        <div class="item item--1">
                            <mat-icon>
                                handshake
                            </mat-icon>
                            <span class="quantity"> {{'Customer_type' | translate}} </span>
                            <span class="text text--1"> {{plantInfo?.customerType}} </span>
                        </div>
                        <div class="item item--2">
                            <mat-icon>
                                price_check
                            </mat-icon>
                            <span class="quantity"> {{'Price_class' | translate}} </span>
                            <span class="text text--2">{{plantInfo?.priceClass}}</span>
                        </div>
                        <div class="item item--3">
                            <mat-icon>
                                candlestick_chart
                            </mat-icon>
                            <span class="quantity">
                                {{'Low_price_threshold' | translate}}
                            </span>
                            <span class="text text--3">
                                {{plantInfo?.lowPriceThreshold}} Kr
                            </span>
                        </div>
                        <div class="item item--4">
                            <mat-icon>
                                location_city
                            </mat-icon>
                            <span class="quantity"> {{'City_name' | translate}} </span>
                            <span class="text text--4"> {{plantInfo?.cityName}} (ID: {{plantInfo?.cityId}})</span>
                        </div>
                    </div>
                </div>
                <div class="col-8 map-holder">
                    <mat-card-content class="daxa-card cart-content map-cart-content" *ngIf="hasCoordinates">
                        <div #map class="leaflet-map"></div>
                    </mat-card-content>

                    <mat-card-content class="cart-content" *ngIf="!hasCoordinates">
                        <span>No location data for this plant.</span>
                    </mat-card-content>
                </div>
            </div>
        </div>
    </div>
    <!-- invertor information -->
    <mat-card class="inverter-horizon-card" *ngFor="let inv of inverterDetail; let i = index">

        <!-- Glow Background -->
        <div class="glow-bg">
        </div>

        <!-- Header -->
        <mat-card-header class="header">

            <!-- Left side (existing content) -->
            <div class="header-left">
                <div mat-card-avatar class="logo-avatar">
                    <mat-icon>solar-energy</mat-icon>
                </div>

                <div class="title-block">
                    <mat-card-title class="brand">
                        {{ inv.brand }}
                        <span class="model-badge">{{ inv.model }}</span>
                    </mat-card-title>

                    <mat-card-subtitle class="meta">
                        <span class="sn">SN: {{ inv.serialNumber }}</span>
                        <span class="divider">•</span>
                        <mat-icon class="clock-icon">schedule</mat-icon>
                        <span>{{'Last_update' | translate}} : {{ inv.lastUpdate | timestampDate }}</span>
                    </mat-card-subtitle>
                </div>
            </div>

            <!-- Right side (new button) -->
            <div class="header-actions">
                <div class="inverter-toggle-card" [class.disabled-state]="isInverterDisabled(inv)">
                    <div class="toggle-copy">
                        <span class="toggle-copy-label">{{ 'Status' | translate }}</span>
                        <span class="toggle-copy-value">
                            {{ isInverterDisabled(inv) ? ('Disabled' | translate) : ('Active' | translate) }}
                        </span>
                    </div>

                    <div class="toggle-control">
                        <mat-icon *ngIf="isInverterToggleBusy(inv)" class="toggle-spinner">autorenew</mat-icon>

                        <mat-slide-toggle color="primary" [checked]="!isInverterDisabled(inv)"
                            [disabled]="isInverterToggleBusy(inv)" (change)="onToggleInverter(inv, $event.checked)">
                        </mat-slide-toggle>
                    </div>
                </div>

                <button mat-icon-button class="header-action" (click)="goToActivityReports(inv)">
                    <mat-icon>bar_chart</mat-icon>
                    {{ "Activity_reports" | translate }}
                </button>

                <button mat-icon-button class="header-action-inveter" (click)="goToEditInverter(inv)">
                    <mat-icon>edit</mat-icon>
                    {{ 'edit_inverter' | translate }}
                </button>
            </div>

        </mat-card-header>

        <!-- Main Content: Horizontal Flow -->
        <mat-card-content class="content">
            <div class="stats-flow">
                <!-- Battery Charge -->
                <div class="stat-item">
                    <div class="icon-wrapper charge">
                        <mat-icon>ev_station</mat-icon>
                        <div class="spark-line"></div>
                    </div>
                    <div class="stat">
                        <div class="label">{{'Battery_Charge' | translate}}</div>
                        <div class="value-invertor">
                            {{ inv.batteryChargePowerRateKw | number:'1.1-1'}}
                            <span class="unit">kW</span>
                        </div>
                    </div>
                </div>

                <!-- Battery Capacity -->
                <div class="stat-item">
                    <div class="icon-wrapper capacity">
                        <mat-icon>battery_full</mat-icon>
                        <div class="progress-ring"
                            [style.--progress]="getBatteryProgress(inv.totalBatteryCapacityKwh, 50)">
                        </div>
                    </div>
                    <div class="stat">
                        <div class="label">{{'Capacity' | translate}}</div>
                        <div class="value-invertor">
                            {{ inv.totalBatteryCapacityKwh | number:'1.1-1'}}
                            <span class="unit">kWh</span>
                        </div>
                    </div>
                </div>

                <!-- Panel Power -->
                <div class="stat-item">
                    <div class="icon-wrapper panel">
                        <mat-icon>solar_power</mat-icon>
                        <div class="wave-animation"></div>
                    </div>
                    <div class="stat">
                        <div class="label">{{'Panel_Power' | translate}}</div>
                        <div class="value-invertor">
                            {{ inv.totalPanelPowerKwh | number:'1.1-1'}}
                            <span class="unit">kW</span>
                        </div>
                    </div>
                </div>

                <!-- Max Production -->
                <div class="stat-item">
                    <div class="icon-wrapper peak">
                        <mat-icon>trending_up</mat-icon>
                        <div class="peak-pulse"></div>
                    </div>
                    <div class="stat">
                        <div class="label">{{'Max_Production' | translate}}</div>
                        <div class="value-invertor">
                            {{ inv.maxProductionCapacity | number:'1.1-1'}}
                            <span class="unit">kW</span>
                        </div>
                    </div>
                </div>

                <!-- Solar Factor Threshold -->
                <div class="stat-item solar-factor">
                    <div class="icon-wrapper factor" [class.empty]="!hasSolarFactorThreshold(inv)">
                        <mat-icon>
                            wb_sunny
                        </mat-icon>
                    </div>

                    <div class="stat">
                        <div class="label">{{'solar threshold' | translate}} </div>

                        <div class="value-invertor value-invertor--list"
                            *ngIf="hasSolarFactorThreshold(inv); else emptySolarFactor">
                            {{ formatSolarFactorThreshold(inv) }}
                        </div>

                        <ng-template #emptySolarFactor>
                            <div class="value-empty">
                                <mat-icon>remove_circle_outline</mat-icon>
                                <span>No threshold</span>
                            </div>
                        </ng-template>
                    </div>
                </div>

                <!-- Plant ID -->
                <div class="stat-item plant">
                    <div class="icon-wrapper">
                        <mat-icon>location_on</mat-icon>
                    </div>
                    <div class="stat">
                        <div class="label">{{'Inverter_ID' | translate}}</div>
                        <div class="value-invertor">#{{ inv.id }}</div>
                    </div>
                </div>
            </div>

            <!-- Metering Points -->
            <div class="metering-tray">
                <div class="tray-header">
                    <mat-icon>electrical_services</mat-icon>
                    <span>{{'Metering_Points' | translate}}</span>
                </div>
                <div class="tray-content">
                    <div class="meter-chip" *ngFor="let point of inv.meteringPointIds" [class.main]="point.isMain">
                        <span class="id">{{ point.meteringPointId }}</span>
                        <span class="type">({{ point.meterType }})</span>
                        <mat-chip class="role" [color]="point.isMain ? 'primary' : 'accent'" selected>
                            {{ point.isMain ? 'MAIN' : 'SUB' }}
                        </mat-chip>
                    </div>
                </div>
            </div>
        </mat-card-content>
    </mat-card>

    <!-- Empty State -->
    <ng-container *ngIf="!inverterDetail?.length">
        <div class="empty-horizon">
            <mat-icon class="empty-icon">power_off</mat-icon>
            <p>{{'No_inverters_online' | translate}}</p>
        </div>
    </ng-container>
</ng-template>